import { render, staticRenderFns } from "./ques13.vue?vue&type=template&id=543d65f3"
import script from "./ques13.vue?vue&type=script&lang=js"
export * from "./ques13.vue?vue&type=script&lang=js"
import style0 from "./ques13.vue?vue&type=style&index=0&id=543d65f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports